import { getBrandCapabilityStatus } from '@/features/hestia/queries/useBrandCapabilities'

/** Namespace + capability identifying the reservations website section. */
export const RESERVATIONS_CAPABILITY = [
  'website-builder',
  'website-reservations',
] as const

/**
 * Whether the reservations website section is gated for the active brand: the
 * MiB display flag is on AND the backend reports the capability disabled. The
 * flag value is passed in so callers can source it from either the static
 * UnleashClient (block modules) or the reactive flag composable (components).
 * @param flagEnabled
 */
export const isReservationsGated = (flagEnabled: boolean): boolean =>
  flagEnabled &&
  getBrandCapabilityStatus(...RESERVATIONS_CAPABILITY) === 'disabled'
